import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const posts = [
  { tag: "Gifting Guide", date: "Oct 2026", title: "Best Corporate Diwali Gifts to Impress Clients in 2026" },
  { tag: "Trends", date: "Oct 2026", title: "Festive Hamper Trends: What Teams Actually Love This Year" },
  { tag: "Etiquette", date: "Sep 2026", title: "The Art of Gifting: Making a Lasting Impression at Work" },
];

const Blog = () => {
  return (
    <section className="relative z-10 bg-[#0d1220] py-24 md:py-28" data-testid="blog-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end"
        >
          <div>
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Gifting journal</span>
            <h2 className="mt-5 font-serif text-4xl leading-[1.08] tracking-tight text-[#F3EEE3] md:text-5xl">
              Ideas & inspiration for{" "}
              <span className="italic text-[#D4AF37]">thoughtful gifting</span>
            </h2>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {posts.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group cursor-pointer overflow-hidden rounded-xl border border-[#F3E5AB]/10 bg-[#111826] transition-all duration-500 hover:border-[#D4AF37]/50 hover:shadow-[0_0_32px_rgba(212,175,55,0.12)]"
              data-testid={`blog-${i}`}
            >
              <div className="shimmer relative flex aspect-[16/10] items-center justify-center">
                <div className="absolute left-1/2 top-1/2 h-2/3 w-2/3 -translate-x-1/2 -translate-y-1/2 bloom-gold opacity-40" />
                <span className="relative rounded-full border border-[#D4AF37]/40 bg-[#0B0F19]/60 px-3 py-1 font-sans text-[10px] uppercase tracking-[0.15em] text-[#F3E5AB] backdrop-blur-md">
                  {p.tag}
                </span>
              </div>
              <div className="p-6">
                <span className="font-sans text-xs uppercase tracking-[0.15em] text-[#8B93A7]">{p.date}</span>
                <h3 className="mt-3 font-serif text-xl leading-snug tracking-tight text-[#F3EEE3] transition-colors duration-300 group-hover:text-[#D4AF37]">
                  {p.title}
                </h3>
                <span className="mt-4 inline-flex items-center gap-1 font-sans text-xs uppercase tracking-[0.15em] text-[#D4AF37]/70 transition-colors duration-300 group-hover:text-[#D4AF37]">
                  Read more <ArrowUpRight className="h-3.5 w-3.5" />
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
